import { useQuery } from '@tanstack/react-query';
import apiClient from '../services/api/apiClient';

export interface WorkflowDefinitionSummary {
  id: string;
  code: string;
  name: string;
  isActive: boolean;
}

/**
 * Fetch the catalog of workflow definitions (Red Dot, Preference Assessment, …).
 * Used by the dynamic Workflows sidebar section and the role-access editor.
 */
export function useWorkflowDefinitions(activeOnly = true) {
  return useQuery({
    queryKey: ['workflow-definitions', { activeOnly }],
    queryFn: async () => {
      const response = await apiClient.get<{ success: boolean; data: WorkflowDefinitionSummary[] }>(
        '/api/v1/workflow-definitions',
        { params: activeOnly ? { active: 'true' } : {} },
      );
      return response.data.data;
    },
    staleTime: 5 * 60_000,
  });
}
